import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: React.CSSProperties["color"];
    };
  }
  interface PaletteColor {
    darker?: string;
  }
  interface SimplePaletteColorOptions {
    darker?: string;
  }
  interface ThemeOptions {
    status: {
      danger: React.CSSProperties["color"];
    };
  }

  interface poster {
    color?: string;
  }
}

// A custom theme for this app
const theme = createTheme({
  typography: {
    caption: { color: "#9c97ba" },
    subtitle1: { color: "#9c97ba" },
    h6: { color: "#9c97ba" },
  },
  status: {
    danger: "#e53e3e",
  },
  palette: {
    mode: "dark",
    primary: {
      main: "#E35561",
      darker: "#432A49",
      contrastText: "#f0f0f0",
    },
    secondary: {
      main: "#793AFF",
      dark: "#362B55",
      darker: "#29223d",
    },
    warning: {
      main: "#F3CA82",
      darker: "#3D3D3D",
      contrastText: "#915d04",
    },
    info: {
      main: "#19A8F5",
      darker: "#374465",
    },
    error: {
      main: "#ED6F86",
    },
    success: {
      main: "#5DC887",
      dark: "#529e70",
      darker: "#194028",
      contrastText: "#f0f0f0",
    },
    text: {
      primary: "#f0f0f0",
      secondary: "#8C87AC",
      disabled: "#7A7597",
    },
    background: {
      default: "#29263D",
      paper: "#2E2B43",
    },
  },
});

export default theme;
